import { action } from 'src/store/actions';

/* Landingpages */
export const FETCH_LANDINGPAGES = 'FETCH_LANDINGPAGES';
export const REQUEST_LANDINGPAGES = 'REQUEST_LANDINGPAGES';
export const SUCCESS_LANDINGPAGES = 'SUCCESS_LANDINGPAGES';
export const FAILURE_LANDINGPAGES = 'FAILURE_LANDINGPAGES';

export const fetchLandingpages = (identifier?: string) => action(FETCH_LANDINGPAGES, { identifier });
export const requestLandingpages = () => action(REQUEST_LANDINGPAGES);
export const requestLandingpagesSuccess = (response: any) => action(SUCCESS_LANDINGPAGES, { response });
export const requestLandingpagesFailure = (error: any) => action(FAILURE_LANDINGPAGES, { error });
